import { memo } from 'react';

import { cn } from '~/utils/cn';

import { getIconComponent } from './iconMap';
import type { PropsIcon } from './interfaces';

function IconView({
  onClick,
  name,
  showBackground,
  size = 24,
  color,
  className,
  disabled = !onClick,
  showBadge,
  rounded = true,
  strokeWidth = 1.75,
}: PropsIcon) {
  const Comp = getIconComponent(name);
  const interactive = !!onClick && !disabled;
  const Wrapper = interactive ? 'button' : 'span';

  return (
    <Wrapper
      type={interactive ? 'button' : undefined}
      onClick={interactive ? onClick : undefined}
      disabled={!interactive ? undefined : false}
      className={cn(
        'relative inline-flex items-center justify-center transition-opacity',
        rounded && 'rounded-full',
        showBackground && 'p-quark bg-intense-03',
        interactive && 'cursor-pointer hover:opacity-80 active:opacity-70',
        !interactive && 'cursor-default',
        className,
      )}
      style={{ width: size + (showBackground ? 8 : 0), height: size + (showBackground ? 8 : 0) }}
    >
      <Comp size={size} color={color} strokeWidth={strokeWidth} />
      {showBadge && (
        <span className="absolute right-0 top-0 h-[10px] w-[10px] rounded-full bg-primary-01 border border-intense-01" />
      )}
    </Wrapper>
  );
}

const Icon = memo(IconView);
export default Icon;
export { Icon };
